export default [
  {
    path: '/teacher-manage',
    name: 'teacher-manage',
    component: () => import(/* webpackChunkName: "teacher-manage" */ './teacher-manage/teacher-manage.vue'),
    meta: {
      menuCode: 'pcPeopleManage',
      menuName: '员工管理',
    },
  },
  {
    path: '/role-manage',
    name: 'role-manage',
    component: () => import(/* webpackChunkName: "role-manage" */ './role-manage/role-manage.vue'),
    meta: {
      menuCode: 'pcAuthManage',
      menuName: '权限管理',
    },
  },
  // {
  //   path: '/material-manage',
  //   name: 'material-manage',
  //   component: () => import(/* webpackChunkName: "material-manage" */ './material-manage/material-manage.vue'),
  //   meta: {
  //     menuCode: 'pcGoodsManage',
  //   },
  // },
  {
    path: '/print-template',
    name: 'print-template',
    component: () => import(/* webpackChunkName: "print-template" */ './print-template/print-template.vue'),
    meta: {
      menuCode: 'receiptTemplateSet',
      menuName: '收据样式设置',
    },
  },
  {
    path: '/contracttemplateimport',
    name: 'contracttemplateimport',
    component: () => import(/* webpackChunkName: "contracttemplateimport" */ './electronic-contract/contract-template-import.vue'),
    meta: {
      noCache: true,
    },
  },
  {
    path: '/electronic-contract',
    name: 'electronic-contract',
    component: () => import(/* webpackChunkName: "electronic-contract" */ './electronic-contract/electronic-contract.vue'),
    meta: {
      menuCode: 'contractManage',
      menuName: '电子合同管理',
    },
  },
  {
    path: '/moment',
    name: 'moment',
    component: () => import(/* webpackChunkName: "moment" */ './moment/moment.vue'),
    meta: {
      menuCode: 'momentManage',
      menuName: '精彩瞬间',
    },
  },
  {
    path: '/make',
    name: 'make',
    component: () => import(/* webpackChunkName: "moment" */ './moment/make/make.vue'),
  },
];
